import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Testimonials({ testimonials }) {
  const [index, setIndex] = useState(0);
  const list = testimonials || [];

  useEffect(() => {
    if (list.length <= 1) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % list.length), 6000);
    return () => clearInterval(t);
  }, [list.length]);

  if (!list.length) return null;
  const go = (d) => setIndex((i) => (i + d + list.length) % list.length);
  const t = list[index];

  return (
    <section
      data-testid="testimonials-section"
      className="bg-espresso text-cream py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <span className="text-[11px] uppercase tracking-[0.3em] text-copper">
            Lo que dicen de nosotras
          </span>
        </Reveal>

        <Quote size={40} strokeWidth={1} className="mx-auto mt-8 text-copper/60" />

        <div className="relative min-h-[240px] md:min-h-[220px] mt-6 flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 flex flex-col items-center justify-center"
            >
              <p className="font-serif font-light text-2xl md:text-4xl leading-snug text-cream max-w-3xl">
                “{t.text}”
              </p>
              <div className="flex items-center gap-1 mt-8">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <Star key={i} size={15} className="fill-copper text-copper" />
                ))}
              </div>
              <p className="mt-4 text-sm uppercase tracking-[0.2em] text-cream">
                {t.name}
              </p>
              {t.location && (
                <p className="text-xs text-cream/50 tracking-wider">{t.location}</p>
              )}
            </motion.div>
          </AnimatePresence>
        </div>

        {list.length > 1 && (
          <div className="flex items-center justify-center gap-4 mt-10">
            <button
              data-testid="testimonial-prev"
              onClick={() => go(-1)}
              className="w-11 h-11 rounded-full border border-cream/30 flex items-center justify-center hover:bg-cream hover:text-espresso transition-colors"
              aria-label="Anterior"
            >
              <ArrowLeft size={16} />
            </button>
            <div className="flex gap-2">
              {list.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    i === index ? "w-6 bg-copper" : "w-1.5 bg-cream/30"
                  }`}
                  aria-label={`Reseña ${i + 1}`}
                />
              ))}
            </div>
            <button
              data-testid="testimonial-next"
              onClick={() => go(1)}
              className="w-11 h-11 rounded-full border border-cream/30 flex items-center justify-center hover:bg-cream hover:text-espresso transition-colors"
              aria-label="Siguiente"
            >
              <ArrowRight size={16} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
